import { action } from "typesafe-actions";
import { WebsocketTypes } from "../types/websocket-types";

export const wsConnect = (host: any) => action(WebsocketTypes.WS_CONNECT, {host});
export const wsMessage = (value: any, host: string) => action(WebsocketTypes.WS_MESSAGE, {value, host});
export const wsSendMessage = (value: any, host: string) => action(WebsocketTypes.WS_SEND_MESSAGE, {value, host});